module.exports = __webpack_public_path__ + "static/media/apartment5.319d0fa2.jpg";